import clsx from 'clsx';
import startCase from 'lodash/startCase';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TemplatesGroup = _ref => {
  let {
    title,
    activeTemplateId,
    templates = [],
    onSelect,
    onFocus,
    onFocusOut
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.group,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.groupTitle,
      children: startCase(title)
    }), /*#__PURE__*/_jsx("div", {
      className: styles.templates,
      children: templates.map((template, index) => {
        return /*#__PURE__*/_jsx(TemplatePreview, {
          name: template.title || 'Unnamed',
          previewImg: `/sharedWidgets/${template.sharedNamespace}/primary.webp`,
          active: activeTemplateId === template.id,
          onClick: () => onSelect(template),
          onMouseEnter: evt => onFocus(evt.currentTarget, template),
          onMouseLeave: onFocusOut
        }, `${title}-${template.id}-${index}`);
      })
    })]
  });
};

const TemplatePreview = _ref2 => {
  let {
    name,
    previewImg,
    active = false,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = _ref2;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: clsx(styles.template, {
      [styles['template--active']]: active
    }),
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: /*#__PURE__*/_jsx("img", {
      src: previewImg,
      alt: `Template preview of ${name}`
    })
  });
};

export default TemplatesGroup;